<template>
  <div class="bb-settings-kpi" :class="{'bb-settings-kpi_view-mode': preview}">
    <h3 class="bb-settings-kpi__title">{{title || namePosition || 'KPI'}}</h3>
    <div
      v-if="isPosition"
      class="bb-form bb-form_settings-kpi"
    >
      <div class="bb-form-item">
        <label class="bb-form__label">Execution Department</label>
        <toggle @toggleChange="toggleExecutionChange"
                type="accent-small"
                :value="executionDepartment.isExecutionDepartment"/>
      </div>
      <div
        class="bb-settings-kpi__disabled"
        :class="{'bb-settings-kpi__disabled_active': !executionDepartment.isExecutionDepartment}"
      >
        <div class="bb-form-item">
          <label class="bb-form__label">Qty. quota</label>
          <input
            class="bb-input bb-input_border"
            type="text"
            v-model="executionDepartment.executionQuota"
            :disabled="!executionDepartment.isExecutionDepartment"/>
        </div>
      </div>
    </div>
    <div class="bb-form bb-form_settings-kpi">
      <div class="bb-form-item">
        <label class="bb-form__label">KPI</label>
        <toggle @toggleChange="toggleChange"
                type="accent-small"
                :value="settings.kpi"/>
      </div>
      <div class="bb-settings-kpi__disabled"
           :class="{'bb-settings-kpi__disabled_active': !settings.kpi}">
      <div class="bb-form-item">
        <label class="bb-form__label" for="80%">80%, AED</label>
        <input class="bb-input bb-input_border"
               id="80%"
               type="text"
               v-autofocus="settings.kpi"
               v-model="settings.percent80"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="100%">100%, AED</label>
        <input class="bb-input bb-input_border"
               id="100%"
               type="text"
               v-model="settings.percent100"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="bonusFromOneTillTwo">+0 - 10,499, %</label>
        <input class="bb-input bb-input_border"
               id="bonusFromOneTillTwo"
               type="text"
               @input="inputPercent(settings.bonusFromOneTillTwo, 'bonusFromOneTillTwo')"
               v-model="settings.bonusFromOneTillTwo"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="bonusFromTwoTillThree">+10,500 - 21,499, %</label>
        <input class="bb-input bb-input_border"
               id="bonusFromTwoTillThree"
               type="text"
               @input="inputPercent(settings.bonusFromTwoTillThree, 'bonusFromTwoTillThree')"
               v-model="settings.bonusFromTwoTillThree"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="bonusFromThreeTillFour">+21,500 - 32,499, %</label>
        <input class="bb-input bb-input_border"
               id="bonusFromThreeTillFour"
               type="text"
               @input="inputPercent(settings.bonusFromThreeTillFour, 'bonusFromThreeTillFour')"
               v-model="settings.bonusFromThreeTillFour"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="bonusMoreThenFour">+32,500 - ∞, %</label>
        <input class="bb-input bb-input_border"
               id="bonusMoreThenFour"
               type="text"
               @input="inputPercent(settings.bonusMoreThenFour, 'bonusMoreThenFour')"
               v-model="settings.bonusMoreThenFour"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="maxBonus">Max bonus amount, AED</label>
        <input class="bb-input bb-input_border"
               id="maxBonus"
               type="text"
               v-model="settings.maxBonus"
               :disabled="settings.kpi === false || preview"/>
      </div>
      <div class="bb-form-item">
        <label class="bb-form__label" for="fixedSalary">Fixed Salary, AED</label>
        <input class="bb-input bb-input_border"
               id="fixedSalary"
               type="text"
               v-model="settings.fixedSalary"
               :disabled="settings.kpi === false || preview"/>
      </div>
    </div>
    </div>
    <button class="bb-button bb-settings-kpi__button" @click="saveSettings" v-if="!preview">SAVE</button>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import toggle from '@/components/Main/Inputs/toggle'
import _ from 'lodash'

export default {
  name: 'SettingsKPI',
  props: ['editPosition', 'preview', 'title', 'isPosition'],
  components: {
    toggle,
    CustomSelect
  },
  data () {
    return {
      settings: {
        kpi: false,
        namePosition: '',
        percent80: '',
        percent100: '',
        bonusFromOneTillTwo: '',
        bonusFromTwoTillThree: '',
        bonusFromThreeTillFour: '',
        bonusMoreThenFour: '',
        maxBonus: 7500,
        fixedSalary: ''
      },
      executionDepartment: {
        isExecutionDepartment: false,
        executionQuota: 0
      },
      keys: {}
    }
  },
  methods: {
    saveSettings () {
      this.checkedInputs()
      if (this.isPosition) {
        this.settings = {
          ...this.settings,
          ...this.executionDepartment
        }
      }
      this.$emit('edit', this.settings)
    },
    toggleChange (data) {
      if (data === 'hide') {
        return
      }
      this.settings.kpi = data
    },
    toggleExecutionChange (data) {
      this.executionDepartment.isExecutionDepartment = data
    },
    checkedInputs () {
      _.forEach(this.settings, (item, index) => {
        const include = this.keys.includes(index)
        if (!include) {
          return
        }
        if (!item && item !== false) {
          this.settings[index] = 0
        } else if (typeof item === 'string') {
          const number = +item.replace(/^0+|[^.\d;]/, '')
          this.settings[index] = isNaN(number) ? 0 : number
        }
      })
    },
    inputPercent (value, key) {
      if (!value) {
        return
      } else if (typeof value === 'string') {
        value = value.replace(/[^.\d;]/g, '')
      }
      if (isNaN(+value)) {
        this.settings[key] = 0
      } else if (+value > 100) {
        this.settings[key] = 100
      } else if (+value === 0) {
        this.settings[key] = 0
      } else {
        this.settings[key] = +value || ''
      }
    }
  },
  beforeMount () {
    this.keys = Object.keys(this.settings)
    const {name, kpi} = this.editPosition
    this.namePosition = name
    const settings = _.cloneDeep(this.editPosition)
    const { isExecutionDepartment, executionQuota, ...all } = settings
    this.settings = all
    this.executionDepartment = {
      isExecutionDepartment,
      executionQuota
    }
    const kpiPosition = _.isUndefined(kpi) ? false : kpi
    this.$set(this.settings, 'kpi', kpiPosition)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../sass/variables";
  @import "../../../../../sass/mixins";

  .bb-settings-kpi {
    @include global-font;

    &__disabled {
      position: relative;

     &:before {
       content: '';
       width: 100%;
       height: 100%;
       position: absolute;
       left: 0;
       top: 0;
       z-index: 10;
       background: rgba($color-white, 0.69);
       opacity: 0;
       pointer-events: none;
       transition: .2s ease-in;
     }

      &_active {
        &:before {
          opacity: 1;
          pointer-events: auto;
        }
      }
    }

    &__title {
      margin-bottom: 25px;
      text-align: center;
      font-weight: 600;
      font-size: 18px;
      line-height: 21px;
    }

    &__select {
      height: 30px;
      font-size: 12px;
    }

    &__button {
      margin: 31px auto 0;
      width: 117px;
      height: 42px;
    }

    &_view-mode {
      .bb-form-item {
        margin-bottom: 9px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .bb-form__label {
        margin-right: 15px;
      }

      .bb-input {
        max-width: 100px;
        padding: 0;
        width: 100%;
        border-color: transparent;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/PositionsList/Positions/SettingsKPI/SettingsKPI.vue